import React, { Component } from 'react';
import logo from '../assets/visual-produce-icon.png';

const iconDimension = "64px"

class SiteIcon extends Component {

    render() {
        return(
            <img src={logo} style={{height: iconDimension, width: iconDimension}} />
        )
    }
}

export default SiteIcon


// WEBPACK FOOTER //
// ./src/components/SiteIcon.js